import React, { Component } from 'react';
import { string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
// import { propTypes } from '../../../util/types';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';
import arrayMutators from 'final-form-arrays';

import { Form, Button, FieldTextInput, H3, H1, FieldCheckboxGroup, H4, H5 } from '../../../components';

import css from './ContactUsForm.module.css';

class ContactUsFormComponent extends Component {
  constructor(props) {
    super(props);
    this.uploadDelayTimeoutId = null;
    this.state = {
      uploadDelay: false,
    };
    this.submittedValues = {};
  }

  componentDidUpdate(prevProps) {
    // Upload delay is additional time window where Avatar is added to the DOM,
    // but not yet visible (time to load image URL from srcset)
    if (prevProps.uploadInProgress && !this.props.uploadInProgress) {
      this.setState({ uploadDelay: true });
      this.uploadDelayTimeoutId = window.setTimeout(() => {
        this.setState({ uploadDelay: false });
      }, UPLOAD_CHANGE_DELAY);
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.uploadDelayTimeoutId);
  }

  render() {
    return (
      <FinalForm
        keepDirtyOnReinitialize={true}
        mutators={{ ...arrayMutators }}
        {...this.props}
        render={fieldRenderProps => {
          const {
            className,
            handleSubmit,
            intl,
            invalid,
            pristine,
            rootClassName,
            form,
            values,
            updateInProgress,
            uploadInProgress,
            formId,
          } = fieldRenderProps;

          const classes = classNames(rootClassName || css.root, className);
          const submitInProgress = updateInProgress;
          const submittedOnce = Object.keys(this.submittedValues).length > 0;
          const pristineSinceLastSubmit = submittedOnce && isEqual(values, this.submittedValues);
          const submitDisabled =
            invalid || pristine || pristineSinceLastSubmit || uploadInProgress || submitInProgress;

          return (
            <Form
              className={classes}
              onSubmit={e => {
                this.submittedValues = values;
                handleSubmit(e);
                form.reset();
              }}
            >
              <div className={css.sectionContainer}>
                <H4 as="h2" className={css.sectionTitle}>
                  <FormattedMessage id="ContactUsForm.contactUsHeading" />
                </H4>

                <H5 as="h2" className={css.sectionInfo}>
                  For any inquiries and assistance, feel free to reach out to our dedicated support team. We are here to help to make your experience on Myfindor as smooth and enjoyable as possible.
                </H5>

                <div className={css.contactInnerWrapper}>
                  <div className={css.nameContainer}>
                    <div className={css.inputRow}>
                      <FieldTextInput
                        className={css.inputBox}
                        type="text"
                        id={formId ? `${formId}.fullName` : 'fullName'}
                        name="fullName"
                        autoComplete="given-name"
                        label={intl.formatMessage({
                          id: 'ContactUsForm.fullNameLabel',
                        })}
                        placeholder={intl.formatMessage({
                          id: 'ContactUsForm.fullNamePlaceholder',
                        })}
                        validate={validators.required(
                          intl.formatMessage({
                            id: 'ContactUsForm.fullNameRequired',
                          })
                        )}
                      />
                      <FieldTextInput
                        className={css.inputBox}
                        type="email"
                        id={formId ? `${formId}.email` : 'email'}
                        name="email"
                        autoComplete="given-email"
                        label={intl.formatMessage({
                          id: 'ContactUsForm.emailLabel',
                        })}
                        placeholder={intl.formatMessage({
                          id: 'ContactUsForm.emailPlaceholder',
                        })}
                        validate={validators.required(
                          intl.formatMessage({
                            id: 'ContactUsForm.emailRequired',
                          })
                        )}
                      />
                    </div>
                    <FieldTextInput
                      className={css.input}
                      type="textarea"
                      id={formId ? `${formId}.enquiry` : 'enquiry'}
                      name="enquiry"
                      autoComplete="given-enquiry"
                      label={intl.formatMessage({
                        id: 'ContactUsForm.enquiryLabel',
                      })}
                      placeholder={intl.formatMessage({
                        id: 'ContactUsForm.enquiryPlaceholder',
                      })}
                      validate={validators.required(
                        intl.formatMessage({
                          id: 'ContactUsForm.enquiryRequired',
                        })
                      )}
                    />
                    <div className={css.formsubmitWrapper}>
                      <Button
                        className={css.submitButton}
                        type="submit"
                        disabled={submitDisabled}
                        inProgress={submitInProgress}
                        ready={pristineSinceLastSubmit}
                      >
                        <FormattedMessage id="ContactUsForm.submit" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      />
    );
  }
}

ContactUsFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  uploadImageError: null,
  updateProfileError: null,
  updateProfileReady: false,
};

ContactUsFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  // from injectIntl
  intl: intlShape.isRequired,
};

const ContactUsForm = compose(injectIntl)(ContactUsFormComponent);

ContactUsForm.displayName = 'ContactUsForm';

export default ContactUsForm;
